module.exports = __webpack_public_path__ + "img/enroll_vb.2dc0c758.png";